import DOMPurify from "dompurify";
export function safeUrl(value, kind = "url") {
  const input = String(value ?? "").trim();
  if (!input) return "";
  if (/[\u0000-\u0020\u007f\\]/.test(input)) return "";
  if (kind === "email") return /^[^\s@:<>()]+@[^\s@:<>()]+\.[^\s@:<>()]+$/.test(input) ? input : "";
  if (kind === "route") return /^\/(?!\/)/.test(input) ? input : "";
  if (/^\/(?!\/)/.test(input) || /^#[a-zA-Z0-9_-]+$/.test(input)) return input;
  try {
    const url = new URL(input);
    if (["https:", "http:"].includes(url.protocol) && !url.username && !url.password) return input;
    if (url.protocol === "mailto:" && safeUrl(input.slice(7).split("?")[0], "email")) return input;
    if (url.protocol === "tel:" && /^tel:\+?[\d()-]+$/.test(input)) return input;
    if (url.protocol === "viber:" && input.startsWith("viber://")) return input;
  } catch (_) {/* Invalid links are never rendered. */}
  return "";
}
export function sanitizeHtml(value) {
  const clean = DOMPurify.sanitize(String(value ?? ""), {
    ALLOWED_TAGS: ["p", "br", "strong", "b", "em", "i", "u", "s", "strike", "blockquote", "ul", "ol", "li", "h1", "h2", "h3", "h4", "span", "div", "a"],
    ALLOWED_ATTR: ["href", "title", "class", "style"],
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
    RETURN_DOM_FRAGMENT: true
  });
  clean.querySelectorAll("[class]").forEach(el => {
    const names = [...el.classList].filter(name => /^ql-(align-(center|right|justify)|indent-[1-8]|direction-rtl)$/.test(name));
    el.removeAttribute("class");
    if (names.length) el.className = names.join(" ");
  });
  clean.querySelectorAll("[style]").forEach(el => {
    const color = el.style.color;
    const background = el.style.backgroundColor;
    el.removeAttribute("style");
    if (/^[#a-zA-Z0-9(),.% -]+$/.test(color)) el.style.color = color;
    if (/^[#a-zA-Z0-9(),.% -]+$/.test(background)) el.style.backgroundColor = background;
  });
  clean.querySelectorAll("a").forEach(el => {
    const href = safeUrl(el.getAttribute("href"));
    if (href) {
      el.setAttribute("href", href);
      el.setAttribute("rel", "noopener noreferrer");
    } else el.removeAttribute("href");
  });
  if (!clean.textContent.replace(/\u00a0/g, " ").trim()) return "";
  const holder = document.createElement("div");
  holder.appendChild(clean);
  return holder.innerHTML;
}
